import type { BookingParticipantRole } from '@visiba/api-vcs-client-v2';

export type AppointmentType = 'physical' | 'video';

export type MessagingType = 'messaging';

export type CaseType = AppointmentType | MessagingType;

export interface Participant {
	role?: BookingParticipantRole;
	descriptiveTitle: string | null;
	title: string | null;
	leftTimestamp: string | null;
	name: string;
	profileImageUrl: string | null;
}

export const APPOINTMENT_UNHANDLED_ISSUES_TRACKING_ID_PREFIX = 'A_';
